export const width = window.innerWidth;
export const height = window.innerHeight;



// WEBPACK FOOTER //
// ./src/config.js